export default __webpack_public_path__ + "static/media/pensioner.16bdc799.png";